var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiji(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0225C32 24.859 24.8365 32.0225 16 32.0225C7.1635 32.0225 0 24.859 0 16.0225C0 16.0263 16 0.0242109 16 0.0224609C24.8365 0.0224609 32 7.18596 32 16.0225Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7.67459V13.071L10.4348 7.67459H16Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34772 16.0223H13.0485L8.34772 9.76143L7.6521 14.631L8.34772 16.0223Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9573 16.0225H16.0001C16.0001 16.0081 16.0001 15.9941 16.0001 15.9797C15.9858 15.994 15.9716 16.0083 15.9573 16.0225Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.37027C16 5.55496 16 3.71027 16 0.0224609H15.9973C7.162 0.0239609 0 7.18677 0 16.0225H8.34781V11.3218L13.0486 16.0225H15.9573C15.9716 16.0082 15.9858 15.994 16.0001 15.9796C16.0001 14.9017 16.0001 13.9399 16.0001 13.0711L11.2992 8.37027H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09454 2.10928C5.5921 3.53422 3.51173 5.6146 2.08679 8.11703V16.0223H6.26073V6.28335V6.28322H15.9999C15.9999 4.96678 15.9999 3.71266 15.9999 2.10928H8.09454Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 14.055L10.3152 8.37039H8.34766V8.37052L15.9996 16.0225H15.9998C15.9998 16.0225 15.9998 14.6658 15.9998 14.055Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0868 10.4575V16.0226C18.0868 19.7501 22.9564 20.8922 22.9564 20.8922C22.9564 20.8922 27.8259 19.7501 27.8259 16.0226V10.4575L22.9564 9.06615L18.0868 10.4575Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8259 10.4573V8.37041H18.0868V10.4573H22.2606V14.6313H18.0868V16.0225V16.0226L22.2606 16.0227V20.6788C22.6805 20.8273 22.9564 20.8921 22.9564 20.8921C22.9564 20.8921 23.2321 20.8274 23.6519 20.6788V16.0226H27.8259V16.0225V14.6313H23.6519V10.4573H27.8259V10.4573Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0224609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiji);
export default __webpack_public_path__ + "static/media/fiji.7c3282ed.svg";
export { ForwardRef as ReactComponent };